import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { ITireTruckImplement } from 'app/shared/model/tire-truck-implement.model';
import { ITireLastOperation } from 'app/shared/model/tire-last-operation.model';
import { serializeAxiosError } from 'app/shared/reducers/reducer.utils';
import { cleanEntity } from 'app/shared/util/entity-utils';
import axios from 'axios';
import { getTireTruckImplementCustomByTruckImplementId } from './tire-truck-implement-custom.reducer';

const initialState = {
  updating: false,
  errorMessage: null,
  updateSuccess: false,
  lastOperation: null as ITireLastOperation | null,
};

export type TireRotationCustomState = Readonly<typeof initialState>;

const apiUrl = 'api/tire-truck-implements-custom';
const tireLastOperationApiUrl = 'api/tire-last-operations';

// Actions

export const getTireLastOperation = createAsyncThunk('tireRotationCustom/fetch_last_operation', async (truckImplementId: number) => {
  const requestUrl = `${tireLastOperationApiUrl}/truck-implement/${truckImplementId}`;
  return axios.get<ITireLastOperation>(requestUrl);
});

export const saveAllTireRotation = createAsyncThunk(
  'tireRotationCustom/create_entity',
  async (entities: ITireTruckImplement[], thunkAPI) => {
    const result = await axios.post<ITireTruckImplement[]>(`${apiUrl}/save-all`, entities.map(cleanEntity));
    const truckImplementId = entities[0].truckImplement?.id;
    if (truckImplementId != null) {
      thunkAPI.dispatch(getTireTruckImplementCustomByTruckImplementId(truckImplementId));
    }
    return result;
  },
  { serializeError: serializeAxiosError }
);

// slice

export const TireRotationCustomSlice = createSlice({
  name: 'tireRotationCustom',
  initialState: initialState as TireRotationCustomState,
  reducers: {
    reset() {
      return initialState;
    },
  },
  extraReducers(builder) {
    builder
      .addMatcher(isFulfilled(saveAllTireRotation), state => {
        state.updating = false;
        state.updateSuccess = true;
      })
      .addMatcher(isFulfilled(getTireLastOperation), (state, action) => {
        state.lastOperation = action.payload.data;
      })
      .addMatcher(isRejected(getTireLastOperation), state => {
        state.lastOperation = null;
      })
      .addMatcher(isPending(saveAllTireRotation), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.updating = true;
      })
      .addMatcher(isRejected(saveAllTireRotation), state => {
        state.updating = false;
        state.updateSuccess = false;
      });
  },
});

export const { reset } = TireRotationCustomSlice.actions;

// Reducer
export default TireRotationCustomSlice.reducer;
